import { MemoryRouter, Routes, Route, HashRouter } from "react-router-dom";
import Subscription from "./Subscription";
import SubscriptionProducts from "./SubscriptionProducts";
import queryString from "query-string";

const SubscriptionPage = () => {
	const parsed = queryString.parse(location.search);
	const { clubId } = parsed;

	if (clubId) {
		return (
			<MemoryRouter>
				<Routes>
					<Route path="/" element={<Subscription />} />
				</Routes>
			</MemoryRouter>
		);
	}

	return (
		<HashRouter>
			<Routes>
				<Route path="/" element={<SubscriptionProducts />} />
				<Route
					path="/subscription/product/:variantId"
					element={<Subscription />}
				/>
			</Routes>
		</HashRouter>
	);
};

export default SubscriptionPage;
